module.exports = __webpack_public_path__ + "media/images/icons/stavyToku-0135b8e99635568d6b56a349a5280a5a.svg";